/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDataPersonalisationFromJSON, ApiDataPersonalisationToJSON, } from './ApiDataPersonalisation';
import { ApiEngagementRuleFromJSON, ApiEngagementRuleToJSON, } from './ApiEngagementRule';
import { ApiJobFromJSON, ApiJobToJSON, } from './ApiJob';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadConversionFromJSON, ApiLeadConversionToJSON, } from './ApiLeadConversion';
import { ApiOpeStatusFromJSON, ApiOpeStatusToJSON, } from './ApiOpeStatus';
import { ApiPageFromJSON, ApiPageToJSON, } from './ApiPage';
import { ApiPageTypeFromJSON, ApiPageTypeToJSON, } from './ApiPageType';
import { ApiPageviewMetaFromJSON, ApiPageviewMetaToJSON, } from './ApiPageviewMeta';
import { ApiProductFromJSON, ApiProductToJSON, } from './ApiProduct';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiSaleFromJSON, ApiSaleToJSON, } from './ApiSale';
import { ApiSessionFromJSON, ApiSessionToJSON, } from './ApiSession';
import { ApiUserAgentFromJSON, ApiUserAgentToJSON, } from './ApiUserAgent';
import { DataPageTypeCalculatedStatusFromJSON, DataPageTypeCalculatedStatusToJSON, } from './DataPageTypeCalculatedStatus';
export function ApiDataFromJSON(json) {
    return ApiDataFromJSONTyped(json, false);
}
export function ApiDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'averageScrollSpeed': !exists(json, 'averageScrollSpeed') ? undefined : json['averageScrollSpeed'],
        'broprintjsKey': !exists(json, 'broprintjsKey') ? undefined : json['broprintjsKey'],
        'cityId': !exists(json, 'cityId') ? undefined : json['cityId'],
        'clsScore': !exists(json, 'clsScore') ? undefined : json['clsScore'],
        'clsValue': !exists(json, 'clsValue') ? undefined : json['clsValue'],
        'conversions': !exists(json, 'conversions') ? undefined : (json['conversions'].map(ApiLeadConversionFromJSON)),
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'domainNameId': !exists(json, 'domainNameId') ? undefined : json['domainNameId'],
        'engagementRules': !exists(json, 'engagementRules') ? undefined : (json['engagementRules'].map(ApiEngagementRuleFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'fbc': !exists(json, 'fbc') ? undefined : json['fbc'],
        'fcpScore': !exists(json, 'fcpScore') ? undefined : json['fcpScore'],
        'fcpValue': !exists(json, 'fcpValue') ? undefined : json['fcpValue'],
        'fingerprintjsKey': !exists(json, 'fingerprintjsKey') ? undefined : json['fingerprintjsKey'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'inpScore': !exists(json, 'inpScore') ? undefined : json['inpScore'],
        'inpValue': !exists(json, 'inpValue') ? undefined : json['inpValue'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
        'isServerSide': !exists(json, 'isServerSide') ? undefined : json['isServerSide'],
        'isVelocity': !exists(json, 'isVelocity') ? undefined : json['isVelocity'],
        'jobImpressions': !exists(json, 'jobImpressions') ? undefined : (json['jobImpressions'].map(ApiJobFromJSON)),
        'key': !exists(json, 'key') ? undefined : json['key'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'lcpScore': !exists(json, 'lcpScore') ? undefined : json['lcpScore'],
        'lcpValue': !exists(json, 'lcpValue') ? undefined : json['lcpValue'],
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'metaUpdatedAt': !exists(json, 'metaUpdatedAt') ? undefined : (new Date(json['metaUpdatedAt'])),
        'metas': !exists(json, 'metas') ? undefined : (json['metas'].map(ApiPageviewMetaFromJSON)),
        'ope': !exists(json, 'ope') ? undefined : json['ope'],
        'opeStatus': !exists(json, 'opeStatus') ? undefined : ApiOpeStatusFromJSON(json['opeStatus']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageId': !exists(json, 'pageId') ? undefined : json['pageId'],
        'pageTypeCalculatedStatus': !exists(json, 'pageTypeCalculatedStatus') ? undefined : DataPageTypeCalculatedStatusFromJSON(json['pageTypeCalculatedStatus']),
        'pageTypes': !exists(json, 'pageTypes') ? undefined : (json['pageTypes'].map(ApiPageTypeFromJSON)),
        'pathNameId': !exists(json, 'pathNameId') ? undefined : json['pathNameId'],
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiDataPersonalisationFromJSON)),
        'productImpressions': !exists(json, 'productImpressions') ? undefined : (json['productImpressions'].map(ApiProductFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'qsParams': !exists(json, 'qsParams') ? undefined : json['qsParams'],
        'referrer': !exists(json, 'referrer') ? undefined : json['referrer'],
        'referrerDomainNameId': !exists(json, 'referrerDomainNameId') ? undefined : json['referrerDomainNameId'],
        'referrerPathId': !exists(json, 'referrerPathId') ? undefined : json['referrerPathId'],
        'regionId': !exists(json, 'regionId') ? undefined : json['regionId'],
        'requestCity': !exists(json, 'requestCity') ? undefined : json['requestCity'],
        'requestCountryCode': !exists(json, 'requestCountryCode') ? undefined : json['requestCountryCode'],
        'requestHashedIp': !exists(json, 'requestHashedIp') ? undefined : json['requestHashedIp'],
        'requestIp': !exists(json, 'requestIp') ? undefined : json['requestIp'],
        'requestLeadKey': !exists(json, 'requestLeadKey') ? undefined : json['requestLeadKey'],
        'requestReferrer': !exists(json, 'requestReferrer') ? undefined : json['requestReferrer'],
        'requestRegion': !exists(json, 'requestRegion') ? undefined : json['requestRegion'],
        'rootPage': !exists(json, 'rootPage') ? undefined : ApiPageFromJSON(json['rootPage']),
        'sales': !exists(json, 'sales') ? undefined : (json['sales'].map(ApiSaleFromJSON)),
        'scrolledPercentage': !exists(json, 'scrolledPercentage') ? undefined : json['scrolledPercentage'],
        'session': !exists(json, 'session') ? undefined : ApiSessionFromJSON(json['session']),
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'timeOnPageSeconds': !exists(json, 'timeOnPageSeconds') ? undefined : json['timeOnPageSeconds'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'userAgent': !exists(json, 'userAgent') ? undefined : ApiUserAgentFromJSON(json['userAgent']),
        'userAgentId': !exists(json, 'userAgentId') ? undefined : json['userAgentId'],
        'viewedPercentage': !exists(json, 'viewedPercentage') ? undefined : json['viewedPercentage'],
    };
}
export function ApiDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'averageScrollSpeed': value.averageScrollSpeed,
        'broprintjsKey': value.broprintjsKey,
        'cityId': value.cityId,
        'clsScore': value.clsScore,
        'clsValue': value.clsValue,
        'conversions': value.conversions === undefined ? undefined : (value.conversions.map(ApiLeadConversionToJSON)),
        'countryId': value.countryId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'domainNameId': value.domainNameId,
        'engagementRules': value.engagementRules === undefined ? undefined : (value.engagementRules.map(ApiEngagementRuleToJSON)),
        'error': value.error,
        'fbc': value.fbc,
        'fcpScore': value.fcpScore,
        'fcpValue': value.fcpValue,
        'fingerprintjsKey': value.fingerprintjsKey,
        'id': value.id,
        'inpScore': value.inpScore,
        'inpValue': value.inpValue,
        'isEffective': value.isEffective,
        'isServerSide': value.isServerSide,
        'isVelocity': value.isVelocity,
        'jobImpressions': value.jobImpressions === undefined ? undefined : (value.jobImpressions.map(ApiJobToJSON)),
        'key': value.key,
        'latitude': value.latitude,
        'lcpScore': value.lcpScore,
        'lcpValue': value.lcpValue,
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'longitude': value.longitude,
        'metaUpdatedAt': value.metaUpdatedAt === undefined ? undefined : (value.metaUpdatedAt.toISOString()),
        'metas': value.metas === undefined ? undefined : (value.metas.map(ApiPageviewMetaToJSON)),
        'ope': value.ope,
        'opeStatus': ApiOpeStatusToJSON(value.opeStatus),
        'page': value.page,
        'pageId': value.pageId,
        'pageTypeCalculatedStatus': DataPageTypeCalculatedStatusToJSON(value.pageTypeCalculatedStatus),
        'pageTypes': value.pageTypes === undefined ? undefined : (value.pageTypes.map(ApiPageTypeToJSON)),
        'pathNameId': value.pathNameId,
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiDataPersonalisationToJSON)),
        'productImpressions': value.productImpressions === undefined ? undefined : (value.productImpressions.map(ApiProductToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'qsParams': value.qsParams,
        'referrer': value.referrer,
        'referrerDomainNameId': value.referrerDomainNameId,
        'referrerPathId': value.referrerPathId,
        'regionId': value.regionId,
        'requestCity': value.requestCity,
        'requestCountryCode': value.requestCountryCode,
        'requestHashedIp': value.requestHashedIp,
        'requestIp': value.requestIp,
        'requestLeadKey': value.requestLeadKey,
        'requestReferrer': value.requestReferrer,
        'requestRegion': value.requestRegion,
        'rootPage': ApiPageToJSON(value.rootPage),
        'sales': value.sales === undefined ? undefined : (value.sales.map(ApiSaleToJSON)),
        'scrolledPercentage': value.scrolledPercentage,
        'session': ApiSessionToJSON(value.session),
        'sessionId': value.sessionId,
        'timeOnPageSeconds': value.timeOnPageSeconds,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'userAgent': ApiUserAgentToJSON(value.userAgent),
        'userAgentId': value.userAgentId,
        'viewedPercentage': value.viewedPercentage,
    };
}
